// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import UploadSlice from './slice/UploadSlice';

export const store = configureStore({
  reducer: {
    upload: UploadSlice
  },
});
